<template>
    <div class="text-nowrap"><span :class="{
        badge: true,
        [`badge-request-status-${slug}`]: true
    }">{{status_text}}</span><span class="small ml-2 text-muted" v-if="withAdditional && status_additional_text">{{status_additional_text}}</span></div>
</template>

<script>
    import RequestStatusData from "../../plugins/request_status_data";
    import _ from "lodash";
    export default {
        name: "RequestStatusBadge",
        props: ['slug', 'withAdditional', 'slug_additional'],
        computed: {
            status_text: function () {
                let data = RequestStatusData.data()[this.slug];
                if (!data) return '';
                return data.short_label ? data.short_label : data.label;
            },
            status_additional_text: function () {
                let data = RequestStatusData.data()[this.slug];
                if (!data) return '';
                let additional_data = data.children ? _.find(data.children, {slug: this.slug_additional}) : null;
                return additional_data ? additional_data.label : null;
            }
        },
    }
</script>

<style scoped>

</style>
